// authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL, verifyResetPasswordOtpApi } from '../../utils/Constants';

export const forgotPasswordVerifyOtp = createAsyncThunk(
    "forgotPasswordVerifyOtp",
    async (payload, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                },
            };
            const response = await axios.put(`${BASE_URL}${verifyResetPasswordOtpApi}`, payload, config);
            return response.data;
        } catch (error) {
            localStorage.removeItem("Token");
            localStorage.removeItem("userId");
            localStorage.removeItem("type");
            return rejectWithValue(
                error?.response?.data?.message || "Failed to login."
            );
        }
    }
);

const forgotPasswordVerifyOtpSlice = createSlice({
    name: 'forgotPasswordOTP',
    initialState: {
        data: null,
        isAuthenticated: false,
        loading: false,
        error: null,
    },
    reducers: {
        clearOtpData: (state) => {
            state.data = null;
            state.error = null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(forgotPasswordVerifyOtp.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(forgotPasswordVerifyOtp.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(forgotPasswordVerifyOtp.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearOtpData } = forgotPasswordVerifyOtpSlice.actions;
export default forgotPasswordVerifyOtpSlice.reducer;
